import { isDefined } from "@clipboard-health/util-ts";
import { TabRouterPath } from "@src/app/routing/constant/tabRoute";
import { useGetATeamWorkplaces } from "@src/appV2/Rankings/useGetATeamWorkplaces";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { RatingCard, RatingCardProps } from "./RatingsCard";
import { CardLoader } from "../CardLoader";
import { pluralizeWorkplace } from "../lang";
import { logViewDetailsClicked } from "../logs";

export function PriorityAccessCard() {
  const history = useHistory();
  const { userId } = useDefinedWorker();

  const { aTeamWorkplacesCount } = useGetATeamWorkplaces();

  const handleAteamClicked = () => {
    logViewDetailsClicked(userId, "a-team");
    history.push(TabRouterPath.RATINGS_A_TEAM);
  };

  const numberOfPriorityAccesses = aTeamWorkplacesCount;

  if (!isDefined(numberOfPriorityAccesses)) {
    return <CardLoader />;
  }

  const aTeamDescription =
    aTeamWorkplacesCount > 0
      ? `${pluralizeWorkplace(aTeamWorkplacesCount)} ${
          aTeamWorkplacesCount === 1 ? "has" : "have"
        } selected you for their A-Team due to your excellent performance! You'll receive Priority Access to their shifts.`
      : "no workplaces have selected you for their A-Team. If selected, you'll receive Priority Access to the workplace's shifts.";

  const aTeamCardProps: RatingCardProps = {
    title: "Priority Plus",
    description: aTeamDescription,
    buttonText: "See details",
    buttonOnClick: handleAteamClicked,
    scoreValue: aTeamWorkplacesCount,
    scoreColor: "shift-priority",
    testId: "a-team",
  };

  return <RatingCard {...aTeamCardProps} />;
}
